( function () {
   
    'use strict';

    ( function ( $ ) {
        var currSlide = 0;
		var nextSlide = 0;

       
        
    } )( jQuery );
} )();

